<!--<div class="pb-2">-->
<!--  <div class="flex p-flex-row font-bold">-->
<!--    {{message.title}} |-->
<!--    {{message.createdAt | date: 'dd/MM/yyyy, HH:mm:ss'}}-->
<!--  </div>-->
<!--  <div class="mt-1 flex p-flex-row">-->
<!--    {{message.content}}-->
<!--    <button *ngIf="!messageRead"-->
<!--            (click)="markAsRead([message.id])" pButton class="p-button-text" label="Mark as read"></button>-->
<!--    <button (click)="handleNotificationClick(message)" pButton class="p-button-text" label="View"></button>-->
<!--  </div>-->
<!--</div>-->

<li class="notification-style" role="menuitem">
  <a
    (click)="handleNotificationClick(message, notificationType)"
    href="javascript:void(0)"
    tabindex="0"
  >
    <!--    TODO CUSTOMIZE TYPE -->
    <i
      [ngClass]="{
        'mi-local-shipping': notificationType === 100,
        'mi-chat-bubble': notificationType === 150,
        'mi-update': notificationType === 175,
        'mi-warning': notificationType === 200,
        'mi-account-balance': notificationType === 250,
        'mi-add-location-alt': notificationType === 300,
        'mi-price-change': notificationType === 400,
        'mi-person-add': notificationType === 500,
        'mi-global': notificationType === 600,
        'mi-inventory': notificationType === 700,
        'mi-crisis-alert': notificationType === 701
      }"
      class="material-icons-outlined mr-2"
      style="font-size: 2rem"
    ></i>

    <div class="notification-item">
      <div
        class="notification-summary flex align-items-center justify-content-between"
      >
        <span>{{ message.title }}</span
        ><small>{{ message.createdAt | date: 'dd/MM HH:mm' }}</small>
      </div>
      <div class="notification -detail">{{ message.content }}</div>
      <div class="flex align-items-center justify-content-end">
        <span>
          <button
            (click)="markAsRead([message.id])"
            *ngIf="!messageRead"
            class="p-button-text"
            label="Mark As Read"
            pButton
            pRipple
            type="button"
          ></button>
        </span>
      </div>
    </div>
  </a>
</li>
